import { loadStripe } from '@stripe/stripe-js';

export const STRIPE_PROMISE = loadStripe(import.meta.env.VITE_STRIPE_PK);
